import Full from './full.vue';

export const componentMap = {
	full: Full
};
